import fetch, { fetchJson } from 'utils/fetch';
import { writeManipForType } from './json';

export const getZones = (intervention, task) =>
  fetchJson(
    `/pco-manager/interventions/${intervention}/zones.json?task_type=${task}`
  );

export const getZoneCopyChoice = intervention =>
  fetchJson(`/pco-manager/interventions/${intervention}/zones-choice.json`);

export const getZoneTemplates = intervention =>
  fetchJson(`/pco-manager/interventions/${intervention}/zone-templates.json`);

export const getInsectSpeciesRef = () =>
  fetchJson(`/pco-manager/refs.json?type=TARGET_INSECT`);

export const getOtherPestsSpeciesRef = () =>
  fetchJson(`/pco-manager/refs.json?type=TARGET_OTHER_PESTS`);

export const getCaptureRangeRef = () =>
  fetchJson(`/pco-manager/refs.json?type=TECH_TASK_CAPTURE`);

const getManipulationsUrlForType = (type, intervention) => {
  switch (type) {
    case 'RAT':
      return `/pco-manager/interventions/${intervention}/manips/rat.json`;
    case 'INSECT':
      return `/pco-manager/interventions/${intervention}/manips/insect.json`;
    case 'DISINFECTION':
      return `/pco-manager/interventions/${
        intervention
      }/manips/disinfection.json`;
    case 'OTHER_PESTS':
      return `/pco-manager/interventions/${
        intervention
      }/manips/other-pests.json`;
    case 'ANNEX_1':
      return `/pco-manager/interventions/${
        intervention
      }/manips/annex.json?task_type=${type}`;
    case 'ANNEX_2':
      return `/pco-manager/interventions/${
        intervention
      }/manips/annex.json?task_type=${type}`;
    default:
      return null;
  }
};

export const getManipulationsForType = (type, intervention) =>
  fetchJson(getManipulationsUrlForType(type, intervention));

const getRenderCreateUrlForType = type => {
  switch (type) {
    case 'RAT':
      return '/pco-manager/manipulations/new.rat';
    case 'INSECT':
      return '/pco-manager/manipulations/new.insect';
    case 'DISINFECTION':
      return '/pco-manager/manipulations/new.disinfection';
    case 'OTHER_PESTS':
      return '/pco-manager/manipulations/new.other-pests';
    case 'ANNEX_1':
      return `/pco-manager/manipulations/new.annex?task_type=${type}`;
    case 'ANNEX_2':
      return `/pco-manager/manipulations/new.annex?task_type=${type}`;
    default:
      return null;
  }
};

export const renderCreateForType = type => {
  const url = getRenderCreateUrlForType(type);
  return fetch(url).then(res => res.text());
};

const getRenderEditUrlForType = type => {
  switch (type) {
    case 'RAT':
      return '/pco-manager/manipulations/edit.rat';
    case 'INSECT':
      return '/pco-manager/manipulations/edit.insect';
    case 'DISINFECTION':
      return '/pco-manager/manipulations/edit.disinfection';
    case 'OTHER_PESTS':
      return '/pco-manager/manipulations/edit.other-pests';
    case 'ANNEX_1':
      return `/pco-manager/manipulations/edit.annex?task_type=${type}`;
    case 'ANNEX_2':
      return `/pco-manager/manipulations/edit.annex?task_type=${type}`;
    default:
      return null;
  }
};

export const renderEditForType = (type, data) => {
  const url = getRenderEditUrlForType(type);
  return fetch(url, {
    method: 'POST',
    body: writeManipForType(type, data),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(res => res.text());
};

const getValidateUrlForType = type => {
  switch (type) {
    case 'RAT':
      return '/pco-manager/manipulations/rat';
    case 'INSECT':
      return '/pco-manager/manipulations/insect';
    case 'DISINFECTION':
      return '/pco-manager/manipulations/disinfection';
    case 'OTHER_PESTS':
      return '/pco-manager/manipulations/other-pests';
    case 'ANNEX_1':
      return `/pco-manager/manipulations/annex?task_type=${type}`;
    case 'ANNEX_2':
      return `/pco-manager/manipulations/annex?task_type=${type}`;
    default:
      return null;
  }
};

export const uploadFile = file => {
  const data = new FormData();
  data.append('file', file);

  return fetch('/pco-manager/async-resource/save', {
    method: 'POST',
    'Content-Type': 'multipart/form-data',
    body: data,
  }).then(res => res.json());
};

export const validateForType = (type, data) =>
  fetch(getValidateUrlForType(type), {
    method: 'POST',
    body: data,
  });

export const getProductManipulations = (product, intervention, ptId) =>
  fetchJson(
    `/pco-manager/manipulations/products.json?product_id=${
      product
    }&intervention_id=${intervention}${ptId ? `&zone_point_id=${ptId}` : ''}`
  );



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/api/index.js